import { find } from "lodash-es";

import { IFileUploadValue } from "shared/components";
import { API_ENDPOINTS } from "shared/constants";

export const useCleanFileOnSubmit = ({
  userId,
  handleSubmit,
  defaultFiles,
}: {
  handleSubmit: (data: any) => void;
  defaultFiles?: IFileUploadValue[];
  userId?: string;
}) => {
  const onSubmit = (data: any) => {
    if (!userId) return;

    let cleanData = data;

    const dataFiles = data.files as IFileUploadValue[];

    const files = dataFiles
      .map((dataFile) => {
        if (dataFile?.file?.url) {
          return {
            user: API_ENDPOINTS.USER(userId),
            url: dataFile.file.url,
          };
        }

        if (dataFile?.originalURL) {
          const id = find(
            defaultFiles,
            ({ originalURL }) => originalURL === dataFile?.originalURL
          )?.id;

          return API_ENDPOINTS.FILE(id || "");
        }

        return undefined;
      })
      .filter((item) => item !== undefined);

    if (dataFiles.length) {
      cleanData = {
        ...data,
        files: files as (string | { user: string; url: string })[],
      };
    }

    handleSubmit(cleanData);
  };

  return { onSubmit };
};
